import React, { useState, useRef, useEffect } from 'react';

import { ToolbarForm } from '../../utils/toolbar-form/ToolbarForm';

import { withLoadPanel } from '../../../utils/withLoadPanel';
import From, { Item as ItemForm, GroupItem, ColCountByScreen } from 'devextreme-react/form';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import Validator, { PatternRule, EmailRule } from 'devextreme-react/validator';
import NumberBox from 'devextreme-react/number-box';
import { USER_STATUS_LIST, GENDERS } from '../../../shared/constants';
import { FormPhoto } from '../../utils/form-photo/FormPhoto';
import { UserStatus } from '../../utils/user-status/UserStatus';
import { FormTextbox } from '../../utils/form-textbox/FormTextbox';
import { confirm } from 'devextreme/ui/dialog';
import { useNavigate } from 'react-router-dom';
import { getApiToken } from '../../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import notify from 'devextreme/ui/notify';
import { useMsal } from "@azure/msal-react";
import ValidationGroup from 'devextreme-react/validation-group';

import './UserForm.scss';
import classNames from 'classnames';
import { DateBox } from 'devextreme-react';
import { FormDateBox } from '../../utils/form-datebox/FormDateBox';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { checkPermission } from '../../../permissions';

const PHOTO_SIZE = 184;


const statusRender = (text) => (
  <div className='status-editor-field'>
    <UserStatus text={text} showText={false} />
    <TextBox
      className={`status-user status-${text?.toLowerCase()}`}
      inputAttr={{ statusEditorInput: '' }}
      readOnly
      text={text}
      hoverStateEnabled={false}
    />
  </div>
);

const statusItemRender = (text) => <UserStatus text={text} />;

export const UserForm = ({ data, isLoading = false, onSave }) => {
      const { instance, accounts } = useMsal();
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState(data.user);
  const [dataSourcePermissiongroups, setDataSourcePermissiongroups] = useState();
  const dataRef = useRef();
  const stylingMode = 'filled';
  const navigate = useNavigate();

  useEffect(() => {

    setFormData(data.user);
    setDataSourcePermissiongroups(data.permissiongroups);

  }, [data]);

  const handleEditClick = () => {
    if (editing === false && formData) {
      dataRef.current = formData;
    } else {
      dataRef.current = undefined;
    }
    setEditing(!editing);
  };

  const onSaveClick = ({ validationGroup }) => {
    if (!validationGroup.validate().isValid) return;
    handleEditClick();
    onSave(formData);
  };

  const onCancelClick = () => {
    setFormData(dataRef.current);
    handleEditClick();
  };

  const updateField = (field) => (value) => {
    if (!formData) return;
    
    setFormData({ ...formData, ...{ [field]: value } });
  };

  const onDeleteUser = () => {
    confirm(`Sind Sie sicher, dass Sie den Benutzer "${formData.displayName}" löschen möchten?`, 'Benutzer löschen')
      .then((confirmed) => {
        if (confirmed) {
          getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
              key: 'userId',
              deleteUrl: `${process.env.REACT_APP_serverEndpoint}/User/DeleteUser`,
              onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                  'Authorization': "Bearer " + token
                };
              },
            });

            dataSource.remove(formData.userId).then(() => {
              notify({
                message: `Benutzer "${formData.displayName}" wurde gelöscht`,
                position: { at: 'bottom center', my: 'bottom center' }
              }, 'success');
              navigate('/user/list');
            }).catch((error) => {
              notify({
                message: `Fehler beim Löschen des Benutzers: ${error.message}`,
                position: { at: 'bottom center', my: 'bottom center' }
              }, 'error');
            });
          });
        }
      });
  };

  return (
    <div className='user-form'>
      <ValidationGroup>
        <ToolbarForm toggleEditing={handleEditClick} onSaveClick={onSaveClick} editing={editing} onCancelClick={onCancelClick} allowEditing={checkPermission("user.edit")} />
        <From
          className={classNames({ 'plain-styled-form': true, 'view-mode': !editing })}
          labelMode='floating'
        >
          <GroupItem colCount={1}>
            <ColCountByScreen xs={1} />
          

          
              <ItemForm>
                <SelectBox
                  label='Status'
                  width='100%'
                  value={formData.status}
                  readOnly={!editing}
                  items={USER_STATUS_LIST}
                  stylingMode={stylingMode}
                  fieldRender={statusRender}
                  itemRender={statusItemRender}
                  onValueChange={updateField('status')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Name'
                  value={formData.displayName}
                  isEditing={!editing}
                  onValueChange={updateField('displayName')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='E-Mail'
                  value={formData.mail}
                  isEditing={!editing}
                  onValueChange={updateField('mail')}
                />
              </ItemForm>

              <ItemForm>
              <FormSelectBox
                label='Rechtegruppe'
                width='100%'
                value={formData.permissiongroupId}
                readOnly={!editing}
                dataSource={dataSourcePermissiongroups}
                displayExpr='permissiongroupname'
                valueExpr='permissiongroupId'
                showClearButton={true}
                onValueChange={updateField('permissiongroupId')}
              />
            </ItemForm>

            {/* <ItemForm cssClass='accent' colSpan={2}>
              <FormTextbox
                label='Geburtsdatum'
                value={formData.dateofbirth}
                isEditing={!editing}
                onValueChange={updateField('dateofbirth')}
              />
            </ItemForm> */}

            {editing && checkPermission("user.delete") && (
              <ItemForm>
                <Button
                  text="Benutzer löschen"
                  type="danger"
                  stylingMode="contained"
                  icon="trash"
                  onClick={onDeleteUser}
                  width="100%"
                />
              </ItemForm>
            )}
          </GroupItem>


        </From>
      </ValidationGroup>
    </div>
  );
};


